"use client";

import * as React from "react";
import styled, { css } from "styled-components";
import defaultTheme from "../defaultTheme";
const StyledCoupon = styled.mark.withConfig({
  displayName: "Coupon__StyledCoupon",
  componentId: "sc-zjckzm-0"
})(["", ""], ({
  theme
}) => css(["display:inline;background:none;font-size:", ";letter-spacing:0.75px;text-transform:uppercase;border:1px dashed ", ";padding:2px ", ";line-height:inherit;font-weight:", ";border-radius:", ";color:", ";"], theme.orbit.fontSizeTextSmall, theme.orbit.paletteCloudDark, theme.orbit.spaceXXSmall, theme.orbit.fontWeightMedium, theme.orbit.borderRadiusNormal, theme.orbit.paletteInkDark));
StyledCoupon.defaultProps = {
  theme: defaultTheme
};
const Coupon = ({
  children,
  dataTest,
  id
}) => /*#__PURE__*/React.createElement(StyledCoupon, {
  "data-test": dataTest,
  id: id
}, children);
export default Coupon;